import { render, staticRenderFns } from "./OptionsLockReasons.vue?vue&type=template&id=1054a034&scoped=true"
import script from "./OptionsLockReasons.vue?vue&type=script&lang=js"
export * from "./OptionsLockReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054a034",
  null
  
)

export default component.exports